/*
 * @Author: Pension 744056574@qq.com
 * @Date: 2022-08-10 10:48:35

 */
// 基础状态
export const baseStatusList: Record<string, any> = {
  "-1": "全部",
  1: "启用",
  0: "禁用",
};
//评价状态
export const evaluationType: Record<string, any> = {
  "-1": "全部",
  1: "显示中",
  0: "已隐藏",
};

// 贸易类型
export const tradeTypeList: Record<string, any> = {
  "-1": "全部",
  1: "一般贸易",
  2: "保税贸易",
  //   3: "快件直邮",
};
// 导出类型
export const exportTypeList: Record<string, any> = {
  "-1": "全部",
  1: "测试导出",
  2: "",
  3: "",
};
// 导出状态
export const exportStatusList: Record<string, any> = {
  0: "生成中",
  1: "已经生成",
  2: "未生成",
  3: "失败",
};
// 商品等级
export const goodsGrade: Record<string, any> = {
  0: "无",
  1: "S级",
  2: "A级",
  3: "B级",
  4: "C级",
  5: "D级",
  6: "E级",
  7: "F级",
  8: "G级",
  9: "H级",
  10: "I级",
  11: "J级",
  12: "K级",
  13: "L级",
  14: "M级",
  15: "N级",
  16: "O级",
  17: "P级",
  18: "Q级",
  19: "R级",
  20: "T级",
  21: "U级",
  22: "V级",
  23: "W级",
  24: "X级",
  25: "Y级",
  26: "Z级",
};

// 优惠券会员类型
export const couponMemberType: Record<string, any> = {
  1: "全部会员",
  2: "指定会员",
  3: "新注册会员",
  4: "美赞臣NUA活动会员",
};
export const memberType: Record<string, any> = {
  1: "全部会员",
  2: "指定会员",
  3: "新注册会员",
};
export const feedCowActivityMemberType: Record<string, any> = {
  1: "全部会员",
  2: "美赞臣新注册会员",
  4: "美赞臣NUA/NSA会员",
};
// 优惠券会员类型
export const couponsendType: Record<string, any> = {
  1: "常规券",
  2: "兑换券",
};
export const memberType1: Record<string, any> = {
  1: "全部会员",
  2: "指定会员",
};
// 门店类型
export const shopType: Record<string, any> = {
  1: "全部门店",
  2: "指定门店参与",
  3: "指定门店不参与",
};
export const shopType1: Record<string, any> = {
  1: "全部门店",
  2: "指定门店",
};
export const shopType2: Record<string, any> = {
  1: "全部门店",
  2: "指定门店参加",
};
// 优惠券发放方式
export const couponSendType: Record<string, any> = {
  1: "注册发放",
  2: "人工注券",
};
// 优惠券状态,  待审核、审核不通过、待开始、发放中、已结束、已作废
export const couponStatus: Record<string, any> = {
  "-2": "全部",
  //   "-1": "强制结束",
  0: "已作废",
  1: "发放中",
  2: "待审核",
  3: "待开始",
  4: "已结束",
  5: "审核不通过",
};
// 礼品券状态,
export const giftCouponStatus: Record<string, any> = {
  "-1": "全部",
  0: "待审核",
  1: "审核不通过",
  2: "待开始",
  3: "发放中",
  4: "已作废",
  5: "已结束",
};
export const giftCouponDistributionType: Record<string, any> = {
  1: "渠道发放",
};
// 优惠券码状态
export const couponCodeStatus: Record<string, any> = {
  "-1": "全部",
  0: "未领取",
  1: "领取",
};
//特价，组合活动状态
export const commbineStatus: Record<string, any> = {
  "-2": "全部",
  //   "-1": "强制结束",
  0: "已作废",
  1: "进行中",
  // 2: "待审核",
  3: "待开始",
  4: "已结束",
  // 5: "审核不通过",
};

// 优惠券类型
export const couponType: Record<string, any> = {
  1: "商品立减券",
  2: "商品折扣券",
};
// 优惠券使用类型
export const couponUseType: Record<string, any> = {
  1: "开始结束时间",
  2: "领取多少天后失效",
};

// 展示角色
export const showRole: Record<string, any> = {
  "-1": "所有角色",
  1: "门店",
  2: "店员",
};
// 店员状态
export const staffStatus: Record<string, any> = {
  "-1": "全部",
  1: "启用",
  0: "禁用",
  2: "离职",
  3: "注销",
};
// 销售状态
export const sellStatus: Record<string, any> = {
  "-1": "全部",
  1: "允许",
  0: "禁止",
};
// 采购权限
export const procureStatus: Record<string, any> = {
  "-1": "全部",
  1: "开启",
  0: "关闭",
};
// 门店状态
export const shopStatus: Record<string, any> = {
  "-1": "全部",
  0: "禁用",
  1: "开启",
  2: "待审核",
  3: "审核拒绝",
  4: "待开通",
  5: "百宝箱开通失败",
  6: "已关闭",
  7: "同步百宝箱失败",
  8: "待关闭平台审核",
  9: "同步中台失败",
  10: "百宝箱开通中",
  11: "待关闭百宝箱审核",
};
// 宝宝性别
export const babySex: Record<string, any> = {
  "-1": "全部",
  1: "男",
  2: "女",
};

// 宝宝过敏症状
export const allergicSymptom: Record<string, any> = {
  //   "-1": "全部",
  1: "皮肤症状",
  2: "胃肠道症状",
  3: "呼吸道症状",
  4: "其他",
  5: "还未发生过敏症状",
};

// 退单方式状态
export const returnStatus: Record<string, any> = {
  "-1": "全部",
  0: "仅退款",
  1: "退货退款",
};
// 推送方式状态
export const pushType: Record<string, any> = {
  0: "全部",
  2: "定时推送",
  1: "立即推送",
};
// 消息状态
export const pushStatus: Record<string, any> = {
  "-1": "全部",
  2: "待推送",
  0: "已取消",
  1: "推送成功",
  3: "推送失败",
};

//提现状态
export const withdrawaStatus: Record<string, any> = {
  "-1": "全部",
  0: "待审核",
  1: "审核拒绝",
  2: "打款中",
  3: "打款成功",
  4: "打款失败",
};
export const withdrawaStatus1: Record<string, any> = {
  0: "待审核",
  2: "审核拒绝",
  1: "打款中",
  3: "打款成功",
  4: "打款失败",
};
export const withdrawaStatu2: Record<string, any> = {
  0: "待审核",
  1: "审核成功",
  2: "审核拒绝",
  4: "打款成功",
  5: "打款失败",
};
//账号类型
export const accountType: Record<string, any> = {
  "-1": "全部",
  1: "门店",
  2: "店员",
};

//账号类型 - 陈列pk赛账号类型
export const accountTypePK: Record<string, any> = {
  "-1": "全部",
  "003": "门店",
  //   "004": "店员",
};

//账户类型
export const accountsType: Record<string, any> = {
  "-1": "全部",
  0: "对公账户",
  1: "对私账户",
};

//账户类型1
export const accountsType1: Record<string, any> = {
  //  0: "全部",
  1: "对公账户",
  2: "对私账户",
};
//活动限制类型
export const actLimitTypes: Record<string, any> = {
  1: "不限制",
  2: "按单限制",
  3: "按听限制",
};

//税金类型
export const taxesTypes: Record<string, any> = {
  2: "活动价",
  1: "原价",
  0: "包税",
};

//活动状态
// export const activityStatus: Record<string, any> = {
//   1: "审核通过",
//   2: "审核拒绝",
//  0: "待审核",
// };
//活动状态
export const activityStatus: Record<string, any> = {
  "-2": "全部",
  //   "-1": "强制结束",
  0: "已作废",
  1: "进行中",
  // 2: "待审核",
  3: "待开始",
  4: "已结束",
  // 5: "审核不通过",
};

//账号类型
export const linkType: Record<string, any> = {
  "003": "门店",
  "004": "店员",
  //   "005": "连锁",
};

//退单方式
export const reType: Record<string, any> = {
  "-1": "全部",
  1: "仅退款",
  2: "退货退款",
};
//退单状态
export const reStatu: Record<string, any> = {
  WAIT_AUDIT: "待审核",
  WAIT_REFUND: "待退款",
  REFUND_ING: "退款中",
  FINISH: "已完成",
  CLOSE: "已关闭",
};

//导出类型
export const importType: Record<string, any> = {
  // 0: "无",
  1: "会员（分佣）订单",
  2: "店员信息",
  3: "会员信息",
  4: "门店信息",
  5: "分佣（分销）商品库存",
  6: "分佣（分销）商品配额",
  7: "C端优惠券领取",
  8: "商品评价",
  9: "提现订单",
  10: "售后订单",
  11: "对账单",
  12: "B端优惠券",
  13: "服务商",
  14: "分销订单",
  15: "分销异常订单",
  16: "分销退单",
  17: "优惠券码",
  18: "扫码出库",
  19: "素材报表",
  20: "礼品券核销",
  21: "门店销售数据",
  22: "返利导入任务",
  23: "返利导入明细",
  24: "返利订单明细",
  25: "销售代表",
  26: "兑换订单",
  27: "礼品卡导入明细",
  28: "礼品卡详情明细",
  29: "配额门店导出",
  30: "商品门店导出",
  31: "养牛礼品门店导出",
  32: "养牛活动门店导出",
  33: "素材活动报表",
  34: "陈列门店导出",
  35: "陈列门店报表导出",
  36: "返利报表导出",
  37: "发票导出",
  38: "积分明细",
  39: "积分账户明细",
  40: "积分兑换订单",
  41: "导出赠品订单",
  42: "导出赠品的城市库存信息",
  43: "积分商品门店导出",
  44: "佣金规则门店导出",
  45: "订单规则渠道指定门店",
  46: "充值管理",
  47: "平台协议",
  48: "导出c端组合活动指定会员",
  49: "导出c端组合活动指定门店",
  50: "扫码出库",
  51: "赠品服务商信息",
};

//是否使用,是否推送成功
export const useType: Record<string, any> = {
  //  0: "全部",
  1: "是",
  0: "否",
};

//是否过期
export const outType: Record<string, any> = {
  //  0: "全部",
  1: "过期",
  0: "未过期",
};
// 是否公告
export const isNoticeType: Record<string, any> = {
  //  0: "全部",
  1: "是",
  0: "否",
};

// 配额门店
export const quotaShopType: Record<string, any> = {
  1: "全部门店",
  2: "指定门店",
  3: "指定省份",
};

//对账单状态
export const billStatus: Record<string, any> = {
  CREATE: "待确认",
  WAIT_FINISH: "待完成",
  FINISH: "已完成",
  CANCEL: "已作废",
};

//对账单类型
export const bankType: Record<string, any> = {
  //  0: "全部",
  1: "对公",
  2: "对私",
};

//直播状态
export const liveStatus: Record<string, any> = {
  "-2": "全部",
  "-1": "已作废",
  2: "进行中",
  0: "待审核",
  1: "未开始",
  3: "已结束",
};
//直播客户端
export const LiveClient: Record<string, any> = {
  //  0: "全部",
  1: "用户小程序",
  2: "门店",
};
//直播商品状态
export const liveGoodsStatus: Record<string, any> = {
  2: "审核通过",
  0: "未审核",
  1: "审核中",
  3: "审核失败",
};
//商品货源
export const goodsSource: Record<string, any> = {
  // 1: "三方平台",
  2: "平台",
};
// 分销订单状态 10-关闭，20-待付款，30-待发货，40-已发货，100-已完成,为了循环排序的问题，全部其实是-1，请求的时候在转换下
export const distributeOrderStatusDic: Record<string, any> = {
  1: "全部",
  10: "关闭",
  20: "待付款",
  21: "待上传凭证", //线下付款状态
  22: "凭证待确认", //线下付款状态
  23: "待采购",
  30: "待发货",
  40: "已发货",
  100: "已完成",
};
// 按照顺序来循环
export const distributeOrderStatusArrDic: Record<string, any> = [
  { id: 1, name: "全部" },
  { id: 20, name: "待付款" },
  { id: 21, name: "待上传凭证" },
  { id: 22, name: "凭证待确认" },
  { id: 23, name: "待采购" },
  { id: 30, name: "待发货" },
  { id: 40, name: "已发货" },
  { id: 100, name: "已完成" },
  { id: 10, name: "关闭" },
];

// 分销订单状态 10-关闭，20-待付款，30-待发货，40-已发货，100-已完成,为了循环排序的问题，全部其实是-1，请求的时候在转换下
export const retailOrderStatusDic: Record<string, any> = {
  1: "全部",
  10: "关闭",
  20: "待付款",
  30: "待发货",
  40: "已发货",
  100: "已完成",
};

// 根角色列表枚举（用于获取登录角色列表和当前登录角色）
export const rootRoleListDic: Record<string, any> = {
  "001": {
    name: "admin",
  },
  "002": {
    name: "supplier",
  },
  "008": {
    name: "service",
  },
};
// 售后订单状态
export const afterSaleStatusDic: Record<string, any> = {
  1: "全部",
  10: "待审核",
  20: "待退款",
  30: "退款中",
  40: "已完成",
  50: "已关闭",
  60: "待退货",
};
// 发票审核状态
export const invoiceStatusDic: Record<string, any> = {
  "-1": "全部",
  1: "待审核",
  2: "开票成功",
  3: "开票失败",
};
// 发票类型
export const invoiceTypeDic: Record<string, any> = {
  "-1": "全部",
  1: "普票",
  2: "专票",
};
// 支付方式
// 支付方式
export const paymentTypeDic: Record<string, any> = {
  "-1": "全部",
  1: "线下支付",
  2: "服务商支付",
  3: "中金支付（商品云）",
  4: "模拟支付",
  5: "招商银行-支付宝",
  6: "招商银行-微信",
  7: "中金-支付宝",
  8: "中金-快捷支付",
  9: "连连支付-微信",
};
// 扫码人类型
export const scanCodePersonType: Record<string, any> = {
  "-1": "全部",
  "003": "门店",
  //   "004": "店员",
};
// 礼品券核销
export const gitCouponVerificationStatusDic: Record<string, any> = {
  "-1": "全部",
  "0": "待核销",
  "1": "已核销",
  "2": "已失效",
};

// 礼品券核销
export const shopStatusDic: Record<string, any> = {
  "0": "禁用",
  "1": "启用",
  "2": "待审核",
  "3": "审核拒绝",
  "4": "待开通",
  "5": "百宝箱开通失败",
  "6": "已关闭",
  "7": "同步百宝箱失败",
  "8": "待关闭平台审核",
  "9": "同步中台失败",
  "10": "百宝箱开通中",
  "11": "待关闭百宝箱审核",
};

// 礼品券核销发货
export const gitCouponSendGoodsStatusDic: Record<string, any> = {
  "0": "待发货",
  "1": "已完成",
  "2": "已关闭",
};
// 链接小工具类型
export const linkSmallToolsDic: Record<string, any> = {
  "1": "超链接",
  "2": "商品链接",
  "3": "素材链接",
  "4": "消息链接",
  "6": "小程序链接",
};
//核销方式
export const writeOffType: Record<string, any> = {
  1: "平台",
  2: "门店",
};
//礼品券状态
export const voucherStatus: Record<string, any> = {
  0: "待审核",
  1: "审核不通过",
  2: "待开始",
  3: "发放中",
  4: "已作废",
  5: "已结束",
};
//扫码激励状态
export const rewardStatus: Record<string, any> = {
  0: "已作废",
  1: "进行中",
  2: "已结束",
  3: "待开始",
};
export const shopTypeList: Record<string, any> = {
  "-1": "全部",
  1: "总店",
  2: "分店",
};
export const shopTypeList1: Record<string, any> = {
  1: "总店",
  2: "分店",
};
//执行状态
export const executeStatus: Record<string, any> = {
  1: "已执行",
  0: "未执行",
};
// 门店类型
export const shopBuyType: Record<string, any> = {
  1: "全部门店",
  2: "指定门店不可购买",
  3: "指定门店可购买",
};
//满减活动
export const giftStatusDic: Record<string, any> = {
  0: "已作废",
  1: "进行中",
  2: "已结束",
  3: "待开始",
  4: "已暂停",
};
// 喂养会员类型
export const feedMemberType: Record<string, any> = {
  1: "全部会员",
  2: "美赞臣新注册会员",
};
export const feedTaskStatus: Record<string, any> = {
  1: "启用",
  0: "禁用",
};
export const feedTaskType: Record<string, any> = {
  1: "签到",
  2: "答题",
  3: "观看视频",
  4: "分享",
};

// 兑换订单状态 -1:全部，10-关闭，30-待发货，40-已发货，100-已完成
export const redeemOrderStatusArrDic: Record<string, any> = [
  { id: 1, name: "全部" },
  { id: 30, name: "待发货" },
  { id: 40, name: "已发货" },
  { id: 100, name: "已完成" },
  { id: 10, name: "关闭" },
];
export const redeemOrderStatusDic: Record<string, any> = {
  1: "全部",
  30: "待发货",
  40: "已发货",
  100: "已完成",
  10: "关闭",
};
export const gameGiftDeliveryTypeDic: Record<string, any> = {
  1: "平台发货",
  2: "门店发货",
};
export const gameGiftDeliveryMethodDic: Record<string, any> = {
  1: "邮寄",
  2: "自提",
};
//c陈列活动
export const displayStatusDic: Record<string, any> = {
  "-1": "全部",
  0: "已作废",
  1: "进行中",
  2: "已结束",
  3: "待开始",
  4: "已暂停",
};
//陈列报表
export const displayAuditStatus: Record<string, any> = {
  "-1": "全部",
  0: "待审核",
  1: "审核通过",
  2: "审核拒绝",
};
export const articleStatusDic: Record<string, any> = {
  1: "已完成",
  0: "未完成",
};
// 积分任务类型
export const jobTypeList: Record<string, any> = {
  1: "分销订单",
  2: "分佣订单金额",
  3: "扫码出库",
  4: "门店等级积分",
  "-1": "所有来源",
};
// 积分变动

export const changeTypeList: Record<string, any> = {
  0: "全部来源",
  1: "分销订单",
  5: "积分增加",
  6: "积分减少",
  7: "积分转赠增加",
  8: "积分转赠减少",
  9: "积分兑换 ",
  10: "积分过期",
};

//会员来源

export const memberSource: Record<string, any> = {
  1: "扫门店或店员二维码",
  2: "扫门店或店员二维码",
  3: "扫门店或店员商品二维码",
  4: "扫门店或店员商品二维码",
  5: "知识库分享",
  6: "扫养牛活动二维码",
  0: "搜索小程序",
  7: "扫常德医院二维码",
};

//下单规则类型

export const orderRuleType: Record<string, any> = {
  1: "跨境下单",
  2: "代借代还",
};
export const orderRuleChannel: Record<string, any> = {
  1: "全部门店",
  2: "指定门店",
};
//充值
export const chargeManaAccountTypeDic: Record<string, any> = {
  "1": "门店",
  "2": "店员",
};
export const chargeManaTradeTypeDic: Record<string, any> = {
  "1": "人工充值",
  "2": "人工扣减",
};
export const chargeManaStatusTypeDic: Record<string, any> = {
  "-1": "全部",
  "1": "待审核",
  "2": "审核通过",
  "3": "审核不通过",
};

export const salesManTypeList: Record<string, any> = {
  "-1": "全部",
  1: "公司",
  2: "个人",
};
export const chargeManaEarningTypeDic: Record<string, any> = {
  "1": "返利收益",
  "2": "活动收益",
};
export const bizDic: Record<string, any> = {
  "1": "订单",
  "2": "售后单",
  "3": "人工充值",
  "4": "人工扣减",
};
export const gitOrderType: Record<string, any> = {
  "-1": "全部",
  "1": "批次库存",
  "2": "实物库存",
};
//佣金规则商品类型
export const commissionGoodType: Record<string, any> = {
  1: "保税商品",
  2: "组合商品",
};
//规格类型
export const specTypeDic: Record<string, any> = {
  1: "小罐",
  2: "大罐",
  3: "礼盒装",
  4: "其他",
};
//规格类型
export const scanDeliveryStatus: Record<string, any> = {
  "-1": "全部",
  1: "待上传",
  2: "待审核",
  3: "审核不通过",
  4: "审核通过",
};

export const scanDeliveryYesOrNoStatus: Record<string, any> = {
  //   "-2": "全部",
  "-1": "全部",
  1: "已推送",
  0: "未推送",
};
export const scanDeliveryActivityType: Record<string, any> = {
  //   "-2": "全部",
  "-1": "全部",
  //   "0": "无",
  1: "NUA活动",
  2: "NSA活动",
};

export const isOrNotAuditBillDic: Record<string, any> = {
  "-1": "全部",
  0: "无需上传",
  1: "待上传",
  2: "待审核",
  3: "审核不通过",
  4: "审核通过",
};

export const liveStatusDic: Record<string, any> = {
  "-1": "全部",
  1: "未开始",
  2: "直播中",
  3: "暂停",
  4: "已结束",
  5: "直播异常",
  6: "禁播",
  7: "已过期",
};
export const liveFrontStatusDic: Record<string, any> = {
  "-1": "全部",
  1: "展示",
  0: "不展示",
};

export const liveGoodsAuditStatusDic: Record<string, any> = {
  0: "未审核",
  1: "审核中",
  2: "审核通过",
  3: "审核失败",
};

export const buyPresentActEditGiftActShop: Record<string, any> = {
  1: "全部城市参加",
  2: "指定城市参加",
  3: "指定服务商参加",
  4: "指定服务商不参加",
  5: "指定城市服务商参加",
};
